import { AxiosPromise } from 'axios';
import { IrUpdateComment } from '../store/irClaimSlice';
import api from './api';

export default function createUpdate(update: Partial<IrUpdateComment>) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.post('/ir-update-comments', update)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function deleteIrUpdateComment(id: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.delete(`/ir-update-comments/${id}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
